export default {
    props: {
        enabled: {
            type: Boolean,
            default: true,
        },
        otherElements: {
            type: Function,
            default: component => []
        },
        min: {
            type: Number,
            default: 0
        },
        postResize: {
            type: Function,
            default: () => {
            }
        },
    },
    data() {
        return {
            postResizeFunction: this.postResize
        }
    },
    methods: {
        resizeElements() {
            this.otherElements(this).forEach((e) => {
                let width = Math.max((this.$el.getBoundingClientRect().width), this.min) + 'px';
                e.style.width = width
                e.style.minWidth = width
            })
            if (this.postResizeFunction) {
                this.postResizeFunction(this);
            }
        },
        resizeEvent(event) {
            this.resizeElements()
        },
    },
    mounted() {
        if (!this.enabled) {
            return
        }

        this.$nextTick(() => {
            this.resizeElements(this.$el)
        })

        this.$el.addEventListener('input', this.resizeEvent)
        this.$on('hook:beforeDestroy', () => {
            delete this.postResizeFunction
            this.$el.removeEventListener('input', this.resizeEvent)
        })
    },
    render() {
        return this.$slots.default[0]
    },
}
